import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLoginMutation } from "../../features/api/authApiSlice";
import { setCredentials } from "./authSlice";
import FuelLoading from "../../pages/FuelLoading";
import "./auth.scss";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [login, { isLoading }] = useLoginMutation();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [formErrors, setFormErrors] = useState({
    email: false,
    password: false,
  });

  // NEW: State to manage password eye toggling visibility
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const newErrors = { email: false, password: false };
    let hasError = false;

    if (!formData.email.trim()) {
      setError("Please enter your email address.");
      newErrors.email = true;
      hasError = true;
    }

    if (!formData.password) {
      setError("Please enter your password.");
      newErrors.password = true;
      hasError = true;
    }

    if (hasError) {
      setFormErrors(newErrors);
      return;
    }

    try {
      const response = await login({
        email: formData.email.trim().toLowerCase(),
        password: formData.password,
      }).unwrap();

      dispatch(
        setCredentials({
          user: response.user,
          accessToken: response.accessToken,
        })
      );
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err?.data?.message || "Invalid credentials. Please try again.");
    }
  };

  return (
    <main className="auth-page">
      {isLoading ? (
        <div className="auth-loading-box">
          <FuelLoading text="Verifying credentials and loading dashboard..." />
        </div>
      ) : (
        <form
          className="auth-card fuel-fade-in"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="auth-card__title">
            <h1>Welcome Back</h1>
            <p>Login to manage Mini Miles Adventures.</p>
          </div>

          <div className="auth-form-group">
            <div className="auth-input-wrapper">
              <label htmlFor="log-email">
                Email Address <span className="required-star">*</span>
              </label>
              <input
                id="log-email"
                name="email"
                type="email"
                className={formErrors.email ? "input-error" : ""}
                value={formData.email}
                onChange={handleChange}
                placeholder="driver@roadtrip.com"
              />
            </div>

            {/* FIXED: Added a nested field container to position eye icon overlays */}
            <div className="auth-input-wrapper">
              <label htmlFor="log-pass">
                Password <span className="required-star">*</span>
              </label>
              <div className="auth-password-field-container">
                <input
                  id="log-pass"
                  name="password"
                  type={showPassword ? "text" : "password"} // Dynamic type switching
                  className={formErrors.password ? "input-error" : ""}
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  className="auth-password-toggle-eye"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? "👁️" : "🙈"}
                </button>
              </div>
            </div>
          </div>

          <Link className="auth-small-link" to="/forgot-password">
            Forgot password?
          </Link>

          {error && <div className="auth-error-banner">{error}</div>}

          <button
            type="submit"
            className="fuel-primary-btn register-submit-btn"
          >
            Login
          </button>

          <footer className="auth-card__footer">
            <span>
              No account yet?{" "}
              <Link to="/register" className="footer-auth-link">
                Register
              </Link>
            </span>
          </footer>
        </form>
      )}
    </main>
  );
}
